import styled from "styled-components";

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  width: 100%;
  height: 100%;

  form {
    display: grid;
    grid-template-columns: repeat(auto-fill, 230px);
    grid-gap: 10px;
    align-items: flex-end;
    width: 100%;
  }
`;
